import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const CREATE_API_KEY = 'CREATE_API_KEY'
const DELETE_API_KEY = 'DELETE_API_KEY'

export const createApiKeyApi = apiCall(
  CREATE_API_KEY,
  ({
    siteId,
    name,
    access = 'read',
  }: {
    siteId: string
    name: string
    access?: 'read' | 'write'
  }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/api-keys`),
    method: 'POST',
    headers: appApiHeaders(),
    body: { name, access },
  }),
)

export const deleteApiKeyApi = apiCall(
  DELETE_API_KEY,
  ({ siteId, id }: { siteId: string; id: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/api-keys/${id}`),
    method: 'DELETE',
    headers: appApiHeaders(),
  }),
)
